module.exports = __webpack_public_path__ + "img/check.23b9fc16.svg";